module.exports = __webpack_public_path__ + "7c5becdab753b3ab426669cad5fc7e77.png";